module.exports = __webpack_public_path__ + "81e5d2736b0c1dc45c41194a6dbe05a6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-marc-03.jpg
 ** module id = 360
 ** module chunks = 0
 **/